module.exports = __webpack_public_path__ + "static/media/AppIconNew.770d5441.svg";